<template>
  <section class="mt-4 prose prose-sm  text-gray-700">
    <p>
      If you have any questions or we have missed any information on our website, 
      please do contact us before purchasing anything. Behind these screens, are 
      real human beings, happy to help you!
    </p>
    <p>
      We understand some things are simply not right, but we are here to help at 
      any time, to avoid as many returns as possible. With online transactions, 
      we can offer a refund, but where possible, it would be fantastic if we 
      could offer an exchange.
    </p>
    <p>
      If you do need to return, we kindly ask that your unneeded goods are returned 
      in resellable condition (tags/labels attached etc) within 14 days of purchasing 
      the item/(s).
    </p>
    <p>
      Postage is to be paid by the customer. 
    </p>
    <p>
      Will will endeavour to refund your as soon as realistically possible. However, 
      please note refunds could take up to 7 days to show in the customer's account.
    </p>
    <p>
      Returns are time consuming for you, but they also have a heavy impact on our 
      environment. It would be fantastic if we can help and advise you, as best as 
      possible to avoid returns. Or, we would prefer you to purchase when you are 
      100% sure it's the right time or item for you.  
    </p>
    <p>
      We appreciate this may lose us sales, but we are just trying our best, to do 
      our best, in every little way we can, especially our ! Please pop us an email 
      if you have any questions, we believe, there's no such thing as a silly question! 
    </p>
    <a href="mailto:hello@kindandconscious.co.uk">hello@kindandconscious.co.uk</a>
  </section>
</template>